import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { useGetCompanies } from '../../../services/lwadmin/company/company-service';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -20px;
`;

const Input = styled.input`
  height: 50px;
  padding: 15px 23px;
  margin-top: 16px;
`;

const Label = styled.label`
  color: ${props => props.theme.bodyColor};
  font-size: 16px;
  margin-top: -20px;
  line-height: 100%;
`;

const CompaniesContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e4eaee;
  border-top: none;
  border-radius: 4px;
  padding: 16px 8px;
`;

const Row = styled.div`
  border-radius: 4px;
  padding: 8px;

  &:hover {
    background-color: #e4eaee;
    cursor: pointer;
  }
`;

const NoResult = styled.div`
  padding: 8px;
`;

export default function CompanySearchControl({ filterExisting, onCompanySelected }) {
  const [, getCompanies] = useGetCompanies();

  const [allCompanies, setAllCompanies] = React.useState([]);
  const [filteredCompanies, setFilteredCompanies] = React.useState([]);
  const [query, setQuery] = React.useState('');

  useChangeAwareEffect(({ isMount }) => {
    isMount && getCompanies().then(({ data }) => {
      const companies = _.get(data, 'companies') || [];
      setAllCompanies(companies);
      setFilteredCompanies(filterExisting(companies));
    });
  }, {});

  const filter = React.useCallback(() => {
    let f = [...filterExisting(allCompanies)];

    if (query.length > 0) {
      const regex = new RegExp(query, 'i');
      f = _.filter(f, company => company.name.match(regex));
    }
    setFilteredCompanies(f);
  }, [filterExisting, allCompanies, query]);

  useChangeAwareEffect(({ did }) => {
    did.query.change && filter();
  }, { query, filter });

  const handleOnChange = e => {
    const newQuery = e.target.value;
    setQuery(newQuery);
  };

  const selectCompany = (e, compnay) => {
    e && e.preventDefault();
    onCompanySelected(compnay);
    setQuery('');
  };

  return (
    <Container>
      <p>Companies &amp; Contributors</p>
      <Label htmlFor="company-serch">
        If you select a Company all contributors within that company will have
        &nbsp;permissions to premium features of the partnership.
      </Label>
      <Input type="text" id="company-search" placeholder="Search for a company" value={query} onChange={handleOnChange} />
      {query.length > 0 && (
        <CompaniesContainer>
          {filteredCompanies.map(company => (
            <Row key={company.id} onClick={e => selectCompany(e, company)}>
              {company.name}
            </Row>
          ))}
          {filteredCompanies.length === 0 && <NoResult>No Result</NoResult>}
        </CompaniesContainer>
      )}
    </Container>
  );
}

CompanySearchControl.propTypes = {
  filterExisting: PropTypes.func.isRequired,
  onCompanySelected: PropTypes.func.isRequired,
};
